<template>
  <div class="mt-4 mb-4">
    <!--Branch -->
    <!-- <div>
      <div class="row mb-2">
        <div class="col">
          <h4 class="">Upload Branches</h4>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <app-upload-file id="branchUpload" :upload-url="uploadTreeUrl" />
        </div>
      </div>

      <div class="row mt-3">
        <div class="col">
          <h4 class="">Download Branches</h4>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col">
          <button class="btn btn-primary d-block" @click="downloadBranches">
            Download
          </button>
        </div>
      </div>
    </div> -->

    <hr />

    <!-- Treatment -->
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col">
          <h4 class="">Upload Treatments</h4>
        </div>
      </div>

      <div class="row">
        <app-disease-tree-selector
          :branchId.sync="branchId"
          class="col-xl-6 col-lg-6 col-md-5 col-sm-6 col-12"
        />
      </div>

      <template v-if="branchId">
        <div v-if="uploadSuccess" class="alert alert-success mt-3 mb-3" role="alert">
    <div class="d-flex align-items-center">
      <span style="font-size: 20px; margin-right: 10px;">✓</span>
      <div>
        <strong>Success!</strong> {{ uploadSuccess }}
      </div>
    </div>
  </div>
  
  <div v-if="uploadError" class="alert alert-danger mt-3 mb-3" role="alert">
    <div class="d-flex align-items-center">
      <span style="font-size: 20px; margin-right: 10px;">✗</span>
      <div>
        <strong>Error!</strong> {{ uploadError }}
      </div>
    </div>
  </div>
        <div class="row mt-4">
          <div class="col">
            <app-upload-file
              id="treatmentUpload"
              :disabled="uploadDisabled"
              :upload-url="uploadBranchUrl"
              :use-force="true"
              @upload-success="handleUploadSuccess"
      @upload-error="handleUploadError"
            />
          </div>
        </div>

        <div v-if="filteredQuestionsList.length > 0">
          <div 
            class="q-condition-container" 
            v-for="(localQuestion, index) in filteredQuestionsList"
            :key="localQuestion.id"
          >
            <!-- First row: Question text (and reference question for autoAnswer) -->
            <div class="question-text-row">
              <div class="question-text">
                {{ localQuestion.question }}
                <div v-if="localQuestion.autoAnswer && localQuestion.referenceQuestionId !== undefined && localQuestion.referenceQuestionId !== null" class="reference-question-text">
                  <strong>Reference:</strong> {{ getReferenceQuestionText(localQuestion.referenceQuestionId) }}
                </div>
              </div>
            </div>

            <!-- Second row: Question dropdown (60%) + Condition (10%) + Answer (30%) -->
            <div class="condition-main-row">
              <tree-select
                class="tree-select-question"
                :disable-branch-nodes="true"
                :clearable="false"
                :searchable="false"
                v-model="state[localQuestion.id].selectedQuestionId"
                :options="variantsOfQuestions.filter((q, i) => q.id !== localQuestion.id && i <= index)"
                @input="(e) => selectQuestion(e, localQuestion)"
              />
              
              <tree-select
                v-if="state[localQuestion.id].selectedQuestionId && state[localQuestion.id].selectedQuestionId !== 'always'"
                class="tree-select-condition"
                :disable-branch-nodes="true"
                :clearable="false"
                :searchable="false"
                v-model="state[localQuestion.id].selectedInclude"
                :options="getInclusionOptions(localQuestion)"
                placeholder="Inclusion"
                @input="(e) => changeInclusion(e, localQuestion)"
              />

              <!-- Answer Selection (for text-based conditions) -->
              <tree-select
                v-if="state[localQuestion.id].selectedQuestionId && 
                      state[localQuestion.id].selectedQuestionId !== 'always' && 
                      state[localQuestion.id].selectedInclude !== 'numericRange'"
                class="tree-select-answer"
                :disable-branch-nodes="true"
                :clearable="false"
                :searchable="false"
                :clear-on-select="true"
                v-model="state[localQuestion.id].selectedAnswerIds"
                :options="state[localQuestion.id].answers"
                placeholder="Select answers"
                :multiple="true"
                :disabled="!state[localQuestion.id].selectedInclude"
                @input="(e) => changeDependentAnswers(e, localQuestion)"
              />
            </div>

            <!-- Third row: Numeric Range Inputs (for numericRange conditions) -->
            <div 
              v-if="state[localQuestion.id].selectedQuestionId && 
                    state[localQuestion.id].selectedQuestionId !== 'always' && 
                    state[localQuestion.id].selectedInclude === 'numericRange'"
              class="numeric-range-row"
            >
              <div class="numeric-range-container">
                <span class="points-label">Points:</span>
                
                <!-- Min Condition -->
                <div class="condition-group">
                  <select 
                    class="form-control operator-select"
                    v-model="state[localQuestion.id].minInclusive"
                    @change="updateNumericRange(localQuestion)"
                  >
                    <option :value="true">≥</option>
                    <option :value="false">></option>
                  </select>
                  <input 
                    type="number" 
                    step="0.1"
                    class="form-control numeric-input"
                    placeholder="Min (optional)"
                    v-model.number="state[localQuestion.id].minValue"
                    @input="updateNumericRange(localQuestion)"
                  />
                </div>
                
                <!-- AND connector -->
                <span class="and-connector">and</span>
                
                <!-- Max Condition -->
                <div class="condition-group">
                  <select 
                    class="form-control operator-select"
                    v-model="state[localQuestion.id].maxInclusive"
                    @change="updateNumericRange(localQuestion)"
                  >
                    <option :value="true">≤</option>
                    <option :value="false"><</option>
                  </select>
                  <input 
                    type="number" 
                    step="0.1"
                    class="form-control numeric-input"
                    placeholder="Max (optional)"
                    v-model.number="state[localQuestion.id].maxValue"
                    @input="updateNumericRange(localQuestion)"
                  />
                </div>
              </div>
            </div>
          </div>
          
          <div class="action-buttons mt-4">
  <button class="btn btn-reset" @click="resetSettings" :disabled="isBtnDisabled">
    Reset
  </button>
  <button class="btn btn-primary" @click="saveSettings" :disabled="isBtnDisabled">
    {{ isBtnDisabled ? 'Saving...' : 'Save'}}
  </button>
</div>
          <div style="color: green;">
            {{ infoMessage }}
          </div>
          <div style="color: red;">
            {{ errorMessage }}
          </div>
        </div>

        <div class="row mt-4">
          <div class="col">
            <h4 class="">Download Treatments</h4>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col">
            <button class="btn btn-primary d-block" @click="downloadTools">
              Download
            </button>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from "vue-property-decorator";
import AppUploadFile from "@/components/AppUploadFile.vue";
import { HttpHandler } from "@/http/HttpHandler";
import AppDiseaseTreeSelector from "@/components/AppDiseaseTreeSelector.vue";
// @ts-ignore
import { Treeselect as TreeSelect } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { Property } from "@/entities/questionaire/Property";
import { AnswerVariant } from "@/entities/questionaire/answers/AnswerVariant";
import { PostBody } from "@/entities/questionaire/dependentQuestions/PostBody";
import { Group } from "@/entities/questionaire/Group";
import store from "@/store/index";

@Component({
  components: {
    AppDiseaseTreeSelector,
    AppUploadFile,
    TreeSelect,
  }
})
export default class DataLoad extends Vue {
  localGroups: Group[] = [];
  branchId: number | null = null;
  private httpHandler: HttpHandler = new HttpHandler(store);
  isBtnDisabled: boolean = false;
  infoMessage: string = '';
  errorMessage: string = '';
  uploadError: string = '';    
  uploadSuccess: string = '';

  state: {
    [q: number]: {
      questionText: string,
      groupName: string,
      questionConditionText?: string,
      groupConditionName?: string,
      selectedQuestionId: number | 'always',
      selectedInclude: string,
      selectedAnswerIds: Array<number | boolean>,
      answers: any[],
      answerQuestionsText: string[],
      answerConditionCount: number,
      // NEW: Numeric range properties
      minValue: number | null,
      maxValue: number | null,
      minInclusive: boolean,
      maxInclusive: boolean,
      // NEW: Show/hide condition flags
      showMinCondition: boolean,
      showMaxCondition: boolean,
    }
  } = {};

  questionsList: Array<Property> = [];
  variantsOfQuestions: Array<Property | {id: string, label: string}> = [];
  inclusion: Array<{id: string, label: string}> = [ 
    { id: 'in', label: 'IN'}, 
    {id: 'notIn', label: 'NOT IN' }, 
    {id: 'numericRange', label: 'Points' } 
  ];

  // NEW: Computed property to filter out questions with specific questionSubType
  get filteredQuestionsList(): Array<Property> {
    return this.questionsList.filter(question => {
      const questionSubType = question.questionSubType;
      return questionSubType !== 'HowMany - SelectOne Range' && questionSubType !== 'HowMany - YesNo';
    });
  }

  // NEW: Method to get reference question text for autoAnswer questions
  getReferenceQuestionText(referenceQuestionId: number | undefined): string {
    if (referenceQuestionId === undefined || referenceQuestionId === null) {
      return 'No reference question';
    }
    const referenceQuestion = this.questionsList.find(q => q.id === referenceQuestionId);
    return referenceQuestion ? referenceQuestion.question : 'Reference question not found';
  }

  // NEW: Get inclusion options based on selected question's questionSubType
  getInclusionOptions(q: Property) {
    const selectedQuestionId = this.state[q.id].selectedQuestionId;
    if (selectedQuestionId && selectedQuestionId !== 'always') {
      const selectedQuestion = this.questionsList.find(question => question.id === selectedQuestionId);
      
      // Skip Points condition for HowMany questions since they're hidden
      if (selectedQuestion && selectedQuestion.questionSubType && selectedQuestion.questionSubType.includes('HowMany')) {
        return [
          { id: 'in', label: 'IN'},
          { id: 'notIn', label: 'NOT IN' }
        ];
      }
    }
    
    // Otherwise show text-based options
    return [
      { id: 'in', label: 'IN'},
      { id: 'notIn', label: 'NOT IN' }
    ];
  }

  // NEW: Copy values from autoAnswer questions to their referenced hidden questions
  copyValuesToHiddenQuestions() {
    // Find all autoAnswer questions with referenceQuestionId
    const autoAnswerQuestions = this.filteredQuestionsList.filter(q => 
      q.autoAnswer && q.referenceQuestionId !== undefined && q.referenceQuestionId !== null
    );

    autoAnswerQuestions.forEach(autoAnswerQuestion => {
      const referenceQuestionId = autoAnswerQuestion.referenceQuestionId!;
      const referencedQuestion = this.questionsList.find(q => q.id === referenceQuestionId);
      
      // Check if referenced question is a hidden type
      if (referencedQuestion && 
          (referencedQuestion.questionSubType === 'HowMany - SelectOne Range' || 
           referencedQuestion.questionSubType === 'HowMany - YesNo')) {
        
        // Copy values from autoAnswer question to the hidden referenced question
        if (this.state[autoAnswerQuestion.id] && this.state[autoAnswerQuestion.id].selectedQuestionId !== 'always') {
          // Initialize state for hidden question if it doesn't exist
          if (!this.state[referenceQuestionId]) {
            this.state[referenceQuestionId] = {
              questionText: referencedQuestion.question,
              groupName: referencedQuestion.groupName!,
              questionConditionText: undefined,
              groupConditionName: undefined,
              selectedQuestionId: 'always',
              selectedInclude: 'none',
              selectedAnswerIds: [],
              answers: [],
              answerQuestionsText: [],
              answerConditionCount: 0,
              minValue: null,
              maxValue: null,
              minInclusive: true,
              maxInclusive: true,
              showMinCondition: false,
              showMaxCondition: false,
            };
          }

          // Copy all relevant values
          const sourceState = this.state[autoAnswerQuestion.id];
          this.state[referenceQuestionId] = {
            ...this.state[referenceQuestionId],
            selectedQuestionId: sourceState.selectedQuestionId,
            selectedInclude: sourceState.selectedInclude,
            selectedAnswerIds: [...sourceState.selectedAnswerIds],
            answers: [...sourceState.answers],
            answerQuestionsText: [...sourceState.answerQuestionsText],
            answerConditionCount: sourceState.answerConditionCount,
            questionConditionText: sourceState.questionConditionText,
            groupConditionName: sourceState.groupConditionName,
            minValue: sourceState.minValue,
            maxValue: sourceState.maxValue,
            minInclusive: sourceState.minInclusive,
            maxInclusive: sourceState.maxInclusive,
          };
        }
      }
    });
  }

  updateComponent() {
    this.$forceUpdate();
  }

  handleUploadSuccess(data: any) {
  console.log('Upload success:', data);
  this.uploadSuccess = typeof data === 'string' ? data : 'File uploaded successfully!';
  this.uploadError = '';
  
  // Auto-hide success message after 5 seconds
  setTimeout(() => {
    this.uploadSuccess = '';
  }, 5000);
  
  // Refresh the data after successful upload
  if (this.branchId) {
    this.getGroups();
  }
}

handleUploadError(error: any) {
  console.log('🔴 handleUploadError called with:', error);
  console.log('🔴🔴🔴 handleUploadError WAS CALLED!', error)
  
  let errorMessage = 'Failed to upload file. Please try again.';
  
  // Try multiple paths to find the error message
  if (error?.response?.Message) {
    errorMessage = error.response.Message;
  } else if (error?.response?.message) {
    errorMessage = error.response.message;
  } else if (error?.message) {
    errorMessage = error.message;
  } else if (error?.fullError?.response?.data?.Message) {
    errorMessage = error.fullError.response.data.Message;
  } else if (error?.type === 'validation') {
    errorMessage = 'File validation failed. Please check the errors and try uploading again.';
  } else if (typeof error === 'string') {
    errorMessage = error;
  }
  
  console.log('🔴 Setting uploadError to:', errorMessage);
  
  this.uploadError = errorMessage;
  this.uploadSuccess = '';
  
  // Force Vue to update
  this.$forceUpdate();
  
  // Auto-hide error message after 10 seconds
  // setTimeout(() => {
  //   this.uploadError = '';
  // }, 10000);
}

  selectQuestion(e: number | 'always', q: Property) {
    this.state[q.id].selectedQuestionId = e;
    this.state[q.id].selectedInclude = 'in';
    this.state[q.id].selectedAnswerIds = [];
    this.state[q.id].answers = [];
    this.state[q.id].groupName = q.groupName!;
    this.state[q.id].questionText = q.label;
    this.state[q.id].answerQuestionsText = [];
    
    // Reset numeric range values
    this.state[q.id].minValue = null;
    this.state[q.id].maxValue = null;
    this.state[q.id].minInclusive = true;
    this.state[q.id].maxInclusive = true;

    if (e !== 'always') {
      const conditionQuestion = this.questionsList.find(question => question.id === e);
      this.state[q.id].groupConditionName = conditionQuestion!.groupName!;
      this.state[q.id].questionConditionText = conditionQuestion!.label;

      const currentChoosenQuestion = this.questionsList.find(question => question.id === e);

      if (currentChoosenQuestion && currentChoosenQuestion.answer.variants) {
        currentChoosenQuestion.answer.variants.map((variant: AnswerVariant) => {
          variant.label = variant.text;
          this.state[q.id].answers.push(variant);
        });
      } else {
        this.state[q.id].answers = [{id: true, label: 'Yes'}, {id: false, label: 'No'}];
      }

      this.state[q.id].answerConditionCount = this.state[q.id].answers.length;
      // Remove automatic numericRange selection since HowMany questions are hidden
      this.state[q.id].selectedInclude = 'in';
    } else {
      this.state[q.id].selectedInclude = 'none';
      this.state[q.id].groupConditionName = undefined;
      this.state[q.id].questionConditionText = undefined;
    }

    // Copy values to hidden questions after any change
    this.copyValuesToHiddenQuestions();
    this.updateComponent();
  }

  changeInclusion(e: string, q: Property) {
    this.state[q.id].selectedInclude = e;
    
    // Reset values when switching between condition types
    if (e === 'numericRange') {
      this.state[q.id].selectedAnswerIds = [];
      this.state[q.id].answerQuestionsText = [];
    } else {
      this.state[q.id].minValue = null;
      this.state[q.id].maxValue = null;
      this.state[q.id].minInclusive = true;
      this.state[q.id].maxInclusive = true;
    }
    
    // Copy values to hidden questions after any change
    this.copyValuesToHiddenQuestions();
    this.updateComponent();
  }

  // NEW: Handle numeric range updates
  updateNumericRange(q: Property) {
    // This method can be used for validation or additional logic
    this.updateComponent();
  }

  changeDependentAnswers(e: Array<number | boolean>, q: Property) {
    let result = [];
    let answerTexts = [];
    const answerVariants = this.questionsList.find(question => question.id === this.state[q.id].selectedQuestionId)?.answer.variants;
            
    if (answerVariants) {
      for (let i = 0; i < answerVariants.length; i++) {
        if (e.includes(answerVariants[i].id)) {
          result.push(answerVariants[i].id);
          answerTexts.push(answerVariants[i].text)
        }
      }
    } else {
      result = e;
      answerTexts = e.map(i => String(i));
    }

    this.state[q.id].selectedAnswerIds = result;
    this.state[q.id].answerQuestionsText = answerTexts;
    
    // Copy values to hidden questions after any change
    this.copyValuesToHiddenQuestions();
  }

  async saveSettings() {
    const body: PostBody[] = [];
    
    // Copy values to hidden questions before saving
    this.copyValuesToHiddenQuestions();
    
    // Process ALL questions (both visible and hidden with copied values)
    Object.entries(this.state).map(([questionId, dependentQuestionInfo], i) => {
      const { 
        selectedAnswerIds, 
        selectedInclude, 
        selectedQuestionId, 
        groupName, 
        groupConditionName, 
        questionText, 
        questionConditionText,
        answerConditionCount,
        answerQuestionsText,
        minValue,
        maxValue,
        minInclusive,
        maxInclusive,
      } = dependentQuestionInfo;

      const bodyItem: PostBody = {
        orderNumber: i,
        questionId: Number(questionId),
        questionText,
        groupName,
        conditionQuestion: selectedInclude,
      }

      if (selectedQuestionId !== 'always') {
        // Handle numeric range conditions
        if (selectedInclude === 'numericRange') {
          body.push(Object.assign(bodyItem, {
            questionConditionId: selectedQuestionId,
            questionConditionText,
            groupConditionName,
            answerQuestions: [],
            answerConditionCount: 0,
            answerQuestionsText: [],
            minValue,
            maxValue,
            minInclusive,
            maxInclusive,
          }));
        } else {
          // Handle text-based conditions
          if (!selectedAnswerIds || selectedAnswerIds.length === 0) {
            this.errorMessage = 'Error: Fill all fields in condition questions';
            setTimeout(() => this.errorMessage = '', 3000);
            return;
          }
          body.push(Object.assign(bodyItem, {
            questionConditionId: selectedQuestionId,
            questionConditionText,
            groupConditionName,
            answerQuestions: selectedAnswerIds.map((id: number | boolean) => String(id)),
            answerConditionCount,
            answerQuestionsText,
          }));
        }
      } else {
        body.push(bodyItem);
      }
    });

    if (!this.errorMessage) {
      this.isBtnDisabled = true;
      try {
        await this.httpHandler.saveDependentQuestionSettings(this.branchId!, body);
        this.infoMessage = 'Saved!'
      } catch (e) {
        this.errorMessage = 'Error saving settings';
      }
      
      this.isBtnDisabled = false;
      setTimeout(() => {
        this.infoMessage = '';
        this.errorMessage = '';
      }, 2000);
    }
  }

  async resetSettings() {
    if (this.localGroups) {
      for (let i = 0; i < this.localGroups.length; i++) {
        const group = this.localGroups[i];
        group.properties.forEach((p) => {
          // UPDATED: Only reset state for questions that are not filtered out
          const questionSubType = p.questionSubType;
          if (questionSubType !== 'HowMany - SelectOne Range' && questionSubType !== 'HowMany - YesNo') {
            this.state[p.id] = {
              questionText: p.question,
              groupName: group.name,
              questionConditionText: undefined,
              groupConditionName: undefined,
              selectedQuestionId: 'always',
              selectedInclude: 'none',
              selectedAnswerIds: [],
              answers: [],
              answerConditionCount: 0,
              answerQuestionsText: [],
              minValue: null,
              maxValue: null,
              minInclusive: true,
              maxInclusive: true,
              showMinCondition: false,
              showMaxCondition: false,
            };
          }
        });
      }
      this.updateComponent();
    }
  }

  @Watch("branchId")
  async getGroups() {
    this.questionsList = [];
    this.state = {};
    this.variantsOfQuestions = [ { id: 'always', label: 'Always show' } ];
    
    if (this.branchId) {
      this.localGroups = await this.httpHandler.getGroupsByBranchId(this.branchId, true);

      if (this.localGroups) {
        for (let i = 0; i < this.localGroups.length; i++) {
          const group = this.localGroups[i];
          group.properties.forEach((p) => {
            p.label = p.question;
            p.groupName = group.name;
            
            // Add all questions to questionsList (needed for reference lookups)
            this.questionsList.push(p);
            
            // Only add non-filtered questions to variantsOfQuestions and state
            const questionSubType = p.questionSubType;
            const shouldSkip = questionSubType === 'HowMany - SelectOne Range' || questionSubType === 'HowMany - YesNo';
            
            if (!shouldSkip) {
              this.variantsOfQuestions.push(p);

              const selectedAnswerIds = p.answerQuestions?.map(id => {
                if (id === 'true') {
                  return true;
                } else if (id === 'false') {
                  return false;
                } else {
                  return Number(id);
                }
              });
              
              this.state[p.id] = {
                questionText: p.question,
                groupName: group.name,
                questionConditionText: p.questionConditionId ? this.questionsList.find(question => question.id === p.questionConditionId)?.label : undefined,
                groupConditionName: p.questionConditionId ? this.questionsList.find(question => question.id === p.questionConditionId)?.groupName : undefined,
                selectedQuestionId: p.questionConditionId || 'always',
                selectedInclude: p.conditionQuestion,
                selectedAnswerIds: selectedAnswerIds || [],
                answers: p.questionConditionId 
                  ? (this.questionsList.find(prop => prop.id === p.questionConditionId)?.answer.variants?.map(el => Object.assign(el, { label: el.text }))
                    || [{id: true, label: 'Yes'}, {id: false, label: 'No'}]) 
                  : [],
                answerConditionCount: p.answerConditionCount || 0,
                answerQuestionsText: p.answerQuestionsText || [],
                // Load numeric range data from API
                minValue: p.minValue || null,
                maxValue: p.maxValue || null,
                minInclusive: p.minInclusive !== undefined ? p.minInclusive : true,
                maxInclusive: p.maxInclusive !== undefined ? p.maxInclusive : true,
                // Keep these for backward compatibility but not used anymore
                showMinCondition: p.minValue !== null && p.minValue !== undefined,
                showMaxCondition: p.maxValue !== null && p.maxValue !== undefined,
              };
            }
          });
        }
      }
    }
  }

  get uploadTreeUrl(): string {
    return new HttpHandler(store).importTreeUrl();
  }

  async downloadBranches() {
    const httpHandler = new HttpHandler(store);
    await httpHandler.exportTree();
  }

  get uploadDisabled(): boolean {
    return this.branchId == null;
  }

  get uploadBranchUrl(): string {
    if (this.branchId == null) return "";

    return new HttpHandler(store).importBranchUrl(this.branchId);
  }

  async downloadTools() {
    if (this.branchId === null) return;
    const httpHandler = new HttpHandler(store);
    await httpHandler.exportTools(this.branchId);
  }
}
</script>

<style scoped>

.action-buttons {
  display: flex;
  gap: 15px;
  align-items: center;
  margin-top: 20px;
}

.btn-reset {
  color: #007bff;
  background-color: white;
  border: 2px solid #007bff;
  padding: 8px 24px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.btn-reset:hover:not(:disabled) {
  background-color: #007bff;
  color: white;
}

.btn-reset:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-primary {
  padding: 8px 24px;
  font-weight: 600;
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.alert {
  padding: 15px 20px;
  border-radius: 8px;
  font-size: 14px;
  animation: slideDown 0.4s ease-out;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.alert-success {
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  color: #155724;
  border-left: 4px solid #28a745;
}

.alert-danger {
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  color: #721c24;
  border-left: 4px solid #dc3545;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.q-condition-container {
  margin: 15px 0;
  border: 1px solid #e9ecef;
  border-radius: 5px;
  padding: 15px;
  background-color: #f8f9fa;
}

.question-text-row {
  margin-bottom: 15px;
}

.question-text {
  font-weight: 500;
  line-height: 1.4;
  color: #333;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.reference-question-text {
  margin-top: 8px;
  padding: 8px 12px;
  background-color: #e3f2fd;
  border-left: 4px solid #2196f3;
  font-size: 14px;
  color: #1565c0;
  border-radius: 4px;
}

.condition-main-row {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 10px;
}

.tree-select-question {
  flex: 0 0 60%;
  min-width: 0;
}

.tree-select-condition {
  flex: 0 0 10%;
  min-width: 80px;
}

.tree-select-answer {
  flex: 0 0 25%;
  min-width: 0;
}

.numeric-range-row {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #dee2e6;
}

.numeric-range-container {
  display: flex;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
}

.points-label {
  font-weight: 500;
  color: #495057;
  flex: 0 0 auto;
}

.condition-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.numeric-input {
  width: 80px;
  height: 32px;
  font-size: 14px;
  padding: 4px 8px;
}

.operator-select {
  width: 50px;
  height: 32px;
  font-size: 12px;
  text-align: center;
  padding: 4px 2px;
}

.add-btn {
  height: 32px;
  font-size: 12px;
  padding: 4px 8px;
}

.remove-btn {
  height: 32px;
  width: 32px;
  font-size: 16px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.and-connector {
  font-weight: 500;
  color: #6c757d;
  font-style: italic;
}

.btn-reset {
  color: #007bff;
  background-color: white;
  border-color: #007bff;
}

.action-btns {
  display: flex;
  margin-top: 20px;
}

/* Responsive adjustments */
@media (max-width: 1200px) {
  .condition-main-row {
    flex-wrap: wrap;
  }
  
  .question-condition {
    flex: 1 1 100%;
    white-space: normal;
    margin-bottom: 10px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}

@media (max-width: 768px) {
  .condition-main-row {
    flex-direction: column;
    align-items: stretch;
  }
  
  .question-condition {
    flex: 1 1 auto;
    min-width: auto;
    max-width: 100%;
    margin-bottom: 10px;
    white-space: normal;
    -webkit-line-clamp: 3;
  }
  
  .tree-select-condition {
    min-width: auto;
    max-width: 100%;
    margin-bottom: 10px;
  }
  
  .numeric-range-container {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
  
  .condition-group {
    justify-content: center;
  }
}
</style>